"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyDiscount = void 0;
function makeEmptyDiscount() {
    return {
        id: 0,
        rate: 0,
        description: '',
        total: 0,
        maxQuotas: 0,
        paymentMethod: '',
    };
}
exports.makeEmptyDiscount = makeEmptyDiscount;
//# sourceMappingURL=Discount.js.map